import React from 'react';
import { EventScheduleTimeSeries } from './EventScheduleTimeSeries/EventScheduleTimeSeries';
import { ExtendedEventGroup } from '../../ExtendedEventGroup.model';
import {
  IItemCreationSubsectionInputProps,
  ItemCreationFieldValue,
  ItemCreationSubsection,
} from '~/Components';
import { ExtendedEvent } from '../../ExtendedEvent.model';
import { EditEventGroupButton } from '../EditEventGroupButton';
import { Typography } from '~/UIKit';
import { useLanguage } from '~/Hooks';
import { makeStyles } from '~/UIKit/Style';
import { EventType } from '~/Models/DTO/Event.model';

const useStyles = makeStyles(() => ({
  emptyState: {
    marginTop: 20,
  },
}));

export const EventScheduleSection = ({
  eventGroup,
  setFieldValue,
  event,
  eventType,
}: {
  eventGroup: ExtendedEventGroup;
  setFieldValue: ItemCreationFieldValue;
  event?: ExtendedEvent;
  eventType: EventType;
}) => {
  const { classes } = useStyles();
  const { t } = useLanguage();

  const ScheduleSectionInputs: IItemCreationSubsectionInputProps<Partial<ExtendedEventGroup>>[] = [
    {
      customElement: (
        <EventScheduleTimeSeries
          setFieldValue={setFieldValue}
          eventType={eventType}
          name={'timeSeries'}
          eventGroupId={eventGroup?.id}
          disabled={!!event}
          defaultSeries={eventGroup?.timeSeries}
        />
      ),
    },
  ];

  return (
    <>
      {!!event && <EditEventGroupButton eventGroup={eventGroup} eventType={event.type} />}
      {!eventGroup?.timeSeries?.some((t) => !t.shouldDelete) && (
        <Typography align="center" className={classes.emptyState} variant="h4">
          {t('event.timeSlot.emptyState')}
        </Typography>
      )}
      <ItemCreationSubsection
        title="EVENT_CREATE_SCHEDULE_SECTION_1"
        isHeaderVisible={false}
        items={ScheduleSectionInputs}
      />
    </>
  );
};
